import React from 'react'

import { Table, Form } from '_zari/core'

import ActualizarComentarioModal from './modals/actualizarComentario'

const FilaDetalleTemplate = ({
  index,
  row,
  actualizarFilaHandler,
  actualizarComentarioHandler,
  eliminarFilaHandler
}) => {
  const [cantidad, setCantidad] = React.useState(row.cantidad)
  const [mostrarActualizarComentarioModal, setMostrarActualizarComentarioModal] = React.useState(
    false
  )

  const keyUpCantidadHandler = e => {
    const keyCode = e.keyCode

    let __focusCantidad = true
    let __focusPrecio = false
    let __focusDescuento = false
    let saltarFila = false
    let saltarCampo = false

    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()

      __focusCantidad = false
      saltarCampo = true
      saltarFila = true
    }
    actualizarFilaHandler({
      ...row,
      cantidad,
      // precio,
      __focusCantidad,
      __focusPrecio,
      __focusDescuento,
      saltarFila,
      saltarCampo
    })
  }

  const keyDownCantidadHandler = e => {
    const keyCode = e.keyCode
    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()
    }
  }

  const clickActualizarComentarioHandler = () => {
    window.setTimeout(() => {
      setMostrarActualizarComentarioModal(true)
    }, 150)
  }

  const actualizarComentarioInnerHandler = ({ comentario }) => {
    setMostrarActualizarComentarioModal(false)
    actualizarComentarioHandler({
      ...row,
      comentario
    })
  }

  const clickEliminarFilaHandler = () => {
    window.setTimeout(() => {
      eliminarFilaHandler(row._idFila)
    }, 150)
  }

  const inputCantidadRef = React.useRef()
  React.useEffect(() => {
    if (row.__filaActiva && row.__focusCantidad) {
      window.setTimeout(() => {
        inputCantidadRef.current.select()
      }, 250)
    }
  }, [row.__filaActiva, row.__focusCantidad])

  return (
    <>
      <tr>
        <td>{parseFloat(index) + 1}</td>
        <td>{row.codigoProducto || '--'}</td>
        <td>
          {row.nombreProducto || '--'} - {row.nombreUnidadDeMedida || '--'}
        </td>
        <td>
          <Form.InputText
            ref={inputCantidadRef}
            placeholder='0'
            value={cantidad}
            onChange={e => setCantidad(e.target.value)}
            onKeyUp={keyUpCantidadHandler}
            onKeyDown={keyDownCantidadHandler}
          />
        </td>
        {/* <td>{row.nombreUnidadDeMedida || '--'}</td> */}
        <td>
          <Table.Dropdown>
            {({ handleClose }) => [
              <Table.Dropdown.Item
                key='comentario'
                handleClose={handleClose}
                onClick={clickActualizarComentarioHandler}
              >
                Comentario
              </Table.Dropdown.Item>,
              <Table.Dropdown.Item
                key='eliminar'
                handleClose={handleClose}
                onClick={clickEliminarFilaHandler}
              >
                Eliminar
              </Table.Dropdown.Item>
            ]}
          </Table.Dropdown>
        </td>
      </tr>
      {mostrarActualizarComentarioModal && (
        <ActualizarComentarioModal
          handleClose={e => setMostrarActualizarComentarioModal(false)}
          show={mostrarActualizarComentarioModal}
          modalData={row}
          actualizarComentarioHandler={actualizarComentarioInnerHandler}
        />
      )}
    </>
  )
}

export default React.memo(FilaDetalleTemplate)
